/**
 * Back to Top Button Functionality
 * Handles scroll-based visibility and smooth scrolling
 * Enhanced with accessibility features
 */

document.addEventListener('DOMContentLoaded', function() {
  const backToTopBtn = document.querySelector('.Shiffa-back-to-top');
  const backToTopButton = document.getElementById('back-to-top-button');
  
  // Throttle scroll function to improve performance
  let isScrolling = false;
  
  if (backToTopBtn) {
    // Set initial state on page load
    if (window.scrollY > 300) {
      backToTopBtn.classList.add('visible');
      backToTopBtn.setAttribute('aria-hidden', 'false');
    }
    
    // Show/hide back to top button based on scroll position
    window.addEventListener('scroll', function() {
      // Throttle the scroll event
      if (!isScrolling) {
        isScrolling = true;
        
        window.requestAnimationFrame(function() {
          if (window.scrollY > 300) {
            backToTopBtn.classList.add('visible');
            backToTopBtn.setAttribute('aria-hidden', 'false');
          } else {
            backToTopBtn.classList.remove('visible');
            backToTopBtn.setAttribute('aria-hidden', 'true');
          }
          
          isScrolling = false;
        });
      }
    }, { passive: true });
    
    // Add keyboard support
    if (backToTopButton) {
      backToTopButton.addEventListener('keydown', function(event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          scrollToTop();
        }
      });
    }
  }
});

// Back to top function
function scrollToTop() {
  // Announce to screen readers
  const announcer = document.createElement('div');
  announcer.setAttribute('aria-live', 'polite');
  announcer.classList.add('sr-only');
  announcer.textContent = 'Scrolling to top of page';
  document.body.appendChild(announcer);
  
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  });
  
  // Remove announcer after scrolling
  setTimeout(() => {
    if (announcer.parentNode) {
      announcer.parentNode.removeChild(announcer);
    }
  }, 1000);
}
